// src/ConsumerApp/Screens/Home/components/BuilderTestimonials.js

import React, { useState } from 'react';
import { theme } from '../../../../assets/theme/theme';
import UserCircle from '../../../../assets/icons/UserCircle.svg';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Chaitanya Gali',
    designation: 'Director, Lakshmi Alekhya Housing Pvt. Ltd',
    website: 'www.lahl.in',
    url: 'https://www.lahl.in/',
    image: '/images/pic_01.png',
    quote:
      'As a builder, time and reliability are everything, and Brickbucket delivers both. I used to spend hours coordinating with multiple suppliers; now, I do it all in a few clicks. It\'s like having a full procurement team in my pocket!',
  },
  {
    id: 2,
    name: 'Bhanu Kambala',
    designation: 'Founder, Minfa Projects',
    website: 'www.minfaprojects.com',
    url: 'https://www.minfaprojects.com/',
    image: '/images/pic_02.png',
    quote:
      'With Brickbucket, sourcing materials has never been easier. The app offers great prices, timely delivery, and real-time tracking—perfect for busy builders like us.',
  },
  {
    id: 3,
    name: 'Srinivas V. Varma',
    designation: 'Managing Partner, SVV Projects & Infra',
    website: 'www.svvinfra.com',
    url: 'https://www.svvinfra.com/',
    image: null, // Will automatically render the clean SVG User Avatar
    quote:
      'Site downtime during casting or plumbing stages used to cost us heavily. With Brickbucket\'s express delivery and verified GST billing, emergency replenishment is completely solved for our team.',
  },
];

// Clean Vector SVG User Avatar for seamless fallback or icon-based profiles
function UserSvgIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      style={{ width: 36, height: 36 }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        fill={theme.colors.brand}
      />
      <path
        d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22"
        stroke={theme.colors.brand}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function TestimonialAvatar({ src, name }) {
  const [hasError, setHasError] = useState(false);

  return (
    <div style={styles.avatarWrapper}>
      {src && !hasError ? (
        <img
          src={src}
          alt={name}
          style={styles.avatarImg}
          onError={() => setHasError(true)}
        />
      ) : (
        <div style={styles.avatarSvgWrap}>
       <img src={UserCircle} alt="camera" style={{ width: 48, height: 48 }} />
        </div>
      )}
    </div>
  );
}

export default function BuilderTestimonials() {
  return (
    <section style={styles.sectionContainer}>
      <style>{`
        .testimonials-grid-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 24px;
          width: 100%;
          padding-top: 36px;
        }

        .testimonial-card-item {
          background-color: #F8FAFC;
          border-radius: ${theme.radius[16]}px;
          border: 1px solid #E2E8F0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          padding: 44px 22px 20px 22px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
          box-sizing: border-box;
        }

        .testimonial-card-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
          border-color: #CBD5E1;
        }

        /* Mobile & Tablet Responsive Horizontal Swipe */
        @media (max-width: 900px) {
          .testimonials-grid-container {
            display: flex;
            overflow-x: auto;
            gap: 16px;
            padding-top: 38px;
            padding-bottom: 12px;
            scroll-snap-type: x mandatory;
            scrollbar-width: none;
            -webkit-overflow-scrolling: touch;
          }
          .testimonials-grid-container::-webkit-scrollbar {
            display: none;
          }
          .testimonial-card-item {
            min-width: 280px;
            max-width: 82vw;
            flex-shrink: 0;
            scroll-snap-align: start;
          }
        }
      `}</style>

      <div style={styles.sectionHeaderRow}>
        <h3 style={styles.sectionTitle}>Builder Testimonials</h3>
      </div>

      <div className="testimonials-grid-container">
        {TESTIMONIALS.map((t) => (
          <div key={t.id} className="testimonial-card-item">
            {/* Centered Profile Avatar or SVG */}
            <TestimonialAvatar src={t.image} name={t.name} />

            {/* Testimonial Quote */}
            <p style={styles.quoteText}>"{t.quote}"</p>

            {/* Author Attribution & Link */}
            <div style={styles.authorSection}>
              <h4 style={styles.authorName}>{t.name}</h4>
              <span style={styles.authorDesignation}>{t.designation}</span>
              <a
                href={t.url}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.authorWebsiteLink}
              >
                {t.website}
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  sectionContainer: {
    marginBottom: `${theme.spacing[300]}px`,
    width: '100%',
  },
  sectionHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: `${theme.spacing[100]}px`,
  },
  sectionTitle: {
    ...theme.typography.headingMD,
    fontSize: 16,
    color: theme.colors.bitumen,
    margin: 0,
  },
  avatarWrapper: {
    width: 68,
    height: 68,
    borderRadius: 34,
    backgroundColor: '#FFFFFF',
    border: '3.5px solid #FFFFFF',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.10)',
    overflow: 'hidden',
    position: 'absolute',
    top: -34,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  avatarSvgWrap: {
    width: '100%',
    height: '100%',
    backgroundColor: '#FFF1F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  quoteText: {
    fontSize: 13,
    lineHeight: '20px',
    color: theme.colors.charcoal,
    fontFamily: theme.typography.bodyMD.fontFamily,
    marginBottom: 18,
    marginTop: 4,
    textAlign: 'left',
    display: 'block',
  },
  authorSection: {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
    paddingTop: 12,
    borderTop: '1px solid #E2E8F0',
  },
  authorName: {
    fontSize: 13.5,
    fontWeight: '700',
    color: theme.colors.brand,
    margin: 0,
    fontFamily: theme.typography.headingMD.fontFamily,
    lineHeight: '18px',
  },
  authorDesignation: {
    fontSize: 11.5,
    color: theme.colors.concrete,
    fontFamily: theme.typography.bodySM.fontFamily,
    lineHeight: '15px',
  },
  authorWebsiteLink: {
    fontSize: 11.5,
    fontWeight: '600',
    color: '#0F4392',
    textDecoration: 'underline',
    marginTop: 2,
    wordBreak: 'break-all',
  },
};